var style = {"container":"DynamicFieldItem-module_container__id87F","item":"DynamicFieldItem-module_item__hki2C","inputContainer":"DynamicFieldItem-module_inputContainer__yUVOn","itemButton":"DynamicFieldItem-module_itemButton__rGyaG"};

export { style as default };
//# sourceMappingURL=DynamicFieldItem.module.scss.js.map
